const O = (N) => N.sort((t, o) => {
  const e = t.compareDocumentPosition(o);
  if (e & Node.DOCUMENT_POSITION_FOLLOWING || e & Node.DOCUMENT_POSITION_CONTAINED_BY)
    return -1;
  if (e & Node.DOCUMENT_POSITION_PRECEDING || e & Node.DOCUMENT_POSITION_CONTAINS)
    return 1;
  if (e & Node.DOCUMENT_POSITION_DISCONNECTED || e & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC)
    throw new Error("Cannot sort the given nodes.");
  return 0;
}), I = (N, t, o) => {
  let e = N + 1;
  return o && e >= t && (e = 0), e;
}, n = (N, t, o) => {
  let e = N - 1;
  return o && e < 0 && (e = t), e;
}, r = (N) => N;
export {
  r as cast,
  I as getNextIndex,
  n as getPrevIndex,
  O as sortNodes
};
//# sourceMappingURL=utils.js.map
